import { memo } from 'react';
import styled from 'styled-components';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const MetadataEditorBox = styled(SkeletonBox).withConfig({
  displayName: "MetadataEditorSkeleton__MetadataEditorBox",
  componentId: "sc-18g4tcn-0"
})(["height:49px;width:100%;display:flex;align-items:center;"]);
const SkeletonRecipient = styled(SkeletonText).withConfig({
  displayName: "MetadataEditorSkeleton__SkeletonRecipient",
  componentId: "sc-18g4tcn-1"
})(["height:24px;margin-left:16px;width:25%;"]);
const MetadataEditorSkeleton = /*#__PURE__*/memo(() => /*#__PURE__*/_jsx(MetadataEditorBox, {
  use: "on-shade",
  children: /*#__PURE__*/_jsx(SkeletonRecipient, {
    use: "blank"
  })
}));
MetadataEditorSkeleton.displayName = 'MetadataEditorSkeleton';
export default MetadataEditorSkeleton;